<template>
  <layout-modal-component
    :close-path="closePath"
    :class="$style.root"
    :style="cssBackgroundColorTextDecoration"
  >
    <template #header>
      <pages-publications-slug-header-component
        :data="data"
        :category="category"
      >
        <shared-edition-relation-component
          :data="data"
        />
      </pages-publications-slug-header-component>
    </template>

    <div
      v-if="data?.coverImage"
      :class="$style.coverImage"
    >
      <shared-publication-image-component
        :image="data?.coverImage"
        :width-in-mm="data?.widthInMm"
      />
    </div>

    <div
      v-if="fileUrl || data?.urlToShop"
      :class="$style.links"
    >
      <layout-animated-underline-component
        v-if="fileUrl"
        :class="$style.link"
        :href="fileUrl"
        target="_blank"
        component="a"
      >
        <template #default>{{ $t('shared.download') }}</template>
      </layout-animated-underline-component>

      <layout-animated-underline-component
        v-if="data?.urlToShop"
        :class="$style.link"
        :href="data?.urlToShop"
        target="_blank"
        component="a"
      >
        <template #default>{{ $t('shared.buy') }}</template>
      </layout-animated-underline-component>
    </div>

    <shared-blocks-component
      v-if="data?.blocks?.length"
      :blocks="data?.blocks"
      :class="$style.blocks"
    />

    <template #footer>
      <layout-prev-next-component
        :prev-path="getPrevNextRouteObject(next?.slug)"
        :next-path="getPrevNextRouteObject(prev?.slug)"
        :prev-label="next?.title"
        :next-label="prev?.title"
      />
    </template>
  </layout-modal-component>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  data: {
    type: Object
  },
  prev: {
    type: Object,
    required: false
  },
  next: {
    type: Object,
    required: false
  }
})

const file = props?.data?.file
const fileUrl = getAbsoluteFileUrl(file?.url, file?.provider)
const category = props?.data?.publicationCategory?.title

const closePath = getClosePath('publications', null, route?.query)

const colors = props?.data?.biennialEntry?.colors
const cssBackgroundColorTextDecoration = getCssBackgroundColorTextDecoration(colors)

const routeName = computed(() => getRouteName())
const routeObject = (slug: string) => {
  return {
    name: routeName.value,
    params: { slug }
  }
}
</script>

<style module lang="scss">
.links {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--stroke--default);
}

.root:has(.blocks) .links {
  margin-bottom: var(--font-default--line-height);
}

.link {
  composes: reset-link button-rectangular font-size-small from global;
  margin-top: var(--font-default--line-height);
}

.coverImage {
  width: 75%;

  margin-left: auto;
  margin-right: auto;
}

.blocks {
  margin-top: calc(var(--font-default--line-height) * 1);
}
</style>
